// extracted by mini-css-extract-plugin
module.exports = {"button_label":"ChangeStatusButton_button_label__1GWrA","button_container":"ChangeStatusButton_button_container__3gl1q"};